module.exports = __webpack_public_path__ + "static/facebook_share-c0acd0991bff4ba22126cc97f7df22d4.jpg";